// frontend/src/pages/InvoiceList.tsx
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { InvoiceApi } from "../lib/api";
import { Link } from "react-router-dom";

const stateColors: Record<string, string> = {
  draft: "bg-gray-100 text-gray-700",
  posted: "bg-green-100 text-green-700",
  cancel: "bg-red-100 text-red-700",
};

export default function InvoiceList() {
  const qc = useQueryClient();
  const { data: invoices, isLoading } = useQuery({ queryKey: ["invoices"], queryFn: () => InvoiceApi.list() });
  const postMut = useMutation({ mutationFn: InvoiceApi.post, onSuccess: () => qc.invalidateQueries({ queryKey: ["invoices"] }) });
  const payMut = useMutation({ mutationFn: InvoiceApi.pay, onSuccess: () => qc.invalidateQueries({ queryKey: ["invoices"] }) });

  if (isLoading) return <p className="text-gray-500">Loading invoices...</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Invoices</h1>
        <Link to="/invoices/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">+ New Invoice</Link>
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Number</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Customer</th>
              <th className="text-center px-4 py-3 font-medium text-gray-600">State</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Total</th>
              <th className="text-center px-4 py-3 font-medium text-gray-600">Paid</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {invoices?.map((inv: any) => (
              <tr key={inv.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{inv.name}</td>
                <td className="px-4 py-3 text-gray-600">{inv.partner_id ?? "—"}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${stateColors[inv.state] ?? ""}`}>{inv.state}</span>
                </td>
                <td className="px-4 py-3 text-right">${inv.amount_total?.toFixed(2)}</td>
                <td className="px-4 py-3 text-center">
                  {inv.paid ? <span className="text-green-600">✓</span> : <span className="text-gray-300">—</span>}
                </td>
                <td className="px-4 py-3 text-right space-x-2">
                  {inv.state === "draft" && <button onClick={() => postMut.mutate(inv.id)} className="text-green-600 hover:text-green-800 text-xs font-medium">Post</button>}
                  {inv.state === "posted" && !inv.paid && <button onClick={() => payMut.mutate(inv.id)} className="text-blue-600 hover:text-blue-800 text-xs font-medium">Mark Paid</button>}
                </td>
              </tr>
            ))}
            {(!invoices || invoices.length === 0) && <tr><td colSpan={6} className="px-4 py-8 text-center text-gray-400">No invoices found</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
